import { Grid } from "@mui/material";
import NavigationDrawer from "../../components/drawer/NavigationDrawer";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import useCorrespondenceService from "../../services/correspondenceService";
import { useAsync } from "../../hooks/useAsync";
import { NAVIGATION_DRAWER_TYPE_CORRESPONDENCE } from "../../components/drawer/NavigationDrawer/NavigationDrawer";
import CorrespondenceRelatedTablesTabs from "../../components/tabs/CorrespondenceRelatedTablesTabs/CorrespondenceRelatedTablesTabs";
import useCheckPermission from "../../hooks/usePermission";
import { EDIT_CORRESPONDENCE_PERMISSION } from "../../helpers/constants";

export default function MyCorrespondencePage(props) {
  const { pageName } = props;
  const { getPostFilteringData } = useCorrespondenceService();
  const postFilteringData = useAsync(getPostFilteringData);


  return (
    <NavigationDrawer
      pageName={pageName}
      drawerType={NAVIGATION_DRAWER_TYPE_CORRESPONDENCE}
    >
      <DefaultPageWrapper titleKey={pageName}>
        <Grid
          container
          item
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          rowSpacing={1}
        >
          <Grid item xs={12}>
            <CorrespondenceRelatedTablesTabs
              pageName={pageName}
              filteringData={postFilteringData}
              hasEditPermission={false}
              isMyCorrespondenceView = {true}
            />
          </Grid> 
        </Grid>
      </DefaultPageWrapper>
    </NavigationDrawer>
  );
}

